export default "__VITE_ASSET__f317a100__"